import { orientation, format } from './';

export class PrintOptions {
    columns: number;
    format: format;
    orientation: orientation;
    rows: number;
}